import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dimmer,
  Grid,
  Header,
  Loader,
  Modal,
  Segment,
  Table,
} from 'semantic-ui-react';
import qs from 'qs';
import { flashErrorMessage } from '../../actions/flash';
import { fetchAPI } from '../../actions/fetchM';

import * as endpoints from '../../constants/apiEndpoints';

import SearchFilter from '../../components/SearchFilter';
import LawyerItem from '../../components/LawyerItem';
import LimitCounter from '../../components/LimitCounter';

export default class LawyersList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onSelect: PropTypes.func,
    onCheck: PropTypes.func,
    queryLimit: PropTypes.number,
    selectLimit: PropTypes.number,
    selected: PropTypes.arrayOf(PropTypes.object),
    loanTrackerProjectID: PropTypes.number,
    onItemClick: PropTypes.func,
  }
  static defaultProps = {
    queryLimit: 10,
    selectLimit: 0,
    loanTrackerProjectID: 0,
    onItemClick: () => {},
  }
  static getPropsToState = (props) => {
    const oriSelected = [].concat(props.selected);
    return {
      oriSelected,
    };
  }
  constructor(props) {
    super(props);
    const state = LawyersList.getPropsToState(props);
    this.state = {
      ...state,
      selected: [],
      data: [],
      loading: true,
      search: '',
      from: 0,
      nextToken: '',
      hasMore: false,
    };
    this.timer = null;
  }
  componentWillReceiveProps(nextProps) {
    const state = LawyersList.getPropsToState(nextProps);
    if (nextProps.loanTrackerProjectID && nextProps.open && this.props.open !== nextProps.open) {
      this.fetchRecentAddedLawyers(nextProps.loanTrackerProjectID);
    }
    this.setState(state);
  }
  componentWillUnmount() {
    this.clearTimer();
  }
  setLawyers = (data = [], state = {}, expand = false) => new Promise((res) => {
    this.setState({
      data: expand ? [].concat(this.state.data, data) : data || [],
      ...state,
    }, () => {
      res(data, ...state);
    });
  })
  setLoading = (loading = false) => new Promise(res => this.setState({ loading }, () => res(loading)))
  setComponentState = (state = {}) => new Promise(res => this.setState(state, () => res(state)))
  clearTimer = () => {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
  fetchRecentAddedLawyers = async (projectID = this.props.loanTrackerProjectID) => {
    await this.setComponentState({ loading: true, data: [] });
    const { store } = this.context;
    if (!projectID) {
      await store.dispatch(flashErrorMessage({ message: 'This project is not linked in loan tracker.' }));
      return;
    }
    const query = {
      limit: 6,
      project_id: projectID,
    };
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.LAWYERS}/?${qs.stringify(query)}`));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }

    if (res) {
      await this.setLawyers(res.items);
    }

    await this.setLoading(false);
  }
  fetchSearchLawyers = async (projectID = this.props.loanTrackerProjectID) => {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { queryLimit } = this.props;
    if (!projectID) {
      await store.dispatch(flashErrorMessage({ message: 'This project is not linked in loan tracker.' }));
      return;
    }
    const query = {
      limit: queryLimit,
      project_id: projectID,
    };
    const { search, from, nextToken } = this.state;
    if (this.state.search) {
      query.search = search;
      query.from = from;
    } else if (nextToken) {
      query.next_token = nextToken;
    }
    let res;
    try {
      res = await store.dispatch(fetchAPI('lawyerAPI', `${endpoints.LAWYERS}/?${qs.stringify(query)}`));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }

    if (res) {
      const state = res.next_token ? {
        nextToken: res.next_token,
        hasMore: !!res.next_token,
        from: 0,
      } : {
        nextToken: '',
        from: from + queryLimit,
        hasMore: res.total_hits > from + queryLimit,
      };
      await this.setLawyers(res.items, state, (!!nextToken || from > 0));
    }

    await this.setLoading(false);
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, this.state.selected.map(s => s.id));
    }
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnSelect = (e, lawyer) => {
    const { search, selected } = this.state;
    if (search === '') {
      return;
    }
    const index = selected.findIndex(b => b.id === lawyer.id);
    if (index < 0) {
      if (this.handleOnCheck(lawyer)) {
        return;
      }
      selected.push(lawyer);
    } else {
      selected.splice(index, 1);
    }
    this.setState({ selected }, () => {
      if (this.props.onSelect) {
        this.props.onSelect(lawyer);
      }
    });
  }
  handleOnCheck = (lawyer) => {
    if (this.props.onCheck) {
      const { selected } = this.state;
      return this.props.onCheck(lawyer, selected);
    }
    return false;
  }
  handleClearFilter = () => {
    this.setState({ search: '', data: [] }, () => {
      this.fetchRecentAddedLawyers();
    });
  }
  handleOnChange = (search) => {
    this.clearTimer();

    if (search !== this.state.search) {
      this.timer = setTimeout(() => {
        this.setState({ search, data: [], from: 0 }, () => {
          this.fetchSearchLawyers();
        });
      }, 500);
    }
  }
  handleLoadMore = () => {
    this.fetchSearchLawyers();
  }
  render() {
    const isLimit = this.props.selectLimit && this.props.selectLimit > 0 && ((this.state.selected.length + this.state.oriSelected.length) >= this.props.selectLimit);
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
        className="items-list-modal"
      >
        <Header
          icon="add"
          content="Add lawyers"
        />
        <Modal.Content>
          <Grid verticalAlign="middle" columns={1}>
            <Grid.Column>
              <SearchFilter
                isLoading={this.state.loading}
                onChange={this.handleOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                disabled={isLimit}
                searchAtKeyEnd
              />
            </Grid.Column>
            <Grid.Column className="list">
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={this.state.loading && this.state.data.length > 0}
              >
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              {
                this.state.search === '' ? (
                  <Header as="h5">Recently added lawyers</Header>
                ) : null
              }
              {
                this.state.data.length > 0 ? (
                  <Table unstackable>
                    <Table.Body>
                      {
                        this.state.data.map((lawyer, idx) => {
                          const isExisted = this.state.oriSelected.some(s => s.lawyer_id === lawyer.id);
                          const isSelected = this.state.selected.some(s => s.id === lawyer.id);
                          return (
                            <Table.Row
                              key={idx}
                              positive={isExisted || isSelected}
                              active={this.handleOnCheck(lawyer)}
                            >
                              <Table.Cell>
                                <LawyerItem
                                  item={lawyer}
                                  onClick={this.handleOnSelect}
                                  selected={isExisted || isSelected}
                                  disabled={this.handleOnCheck(lawyer) || isExisted || isLimit}
                                  checkable={this.state.search.length > 0}
                                  rightComponentTextAlign="right"
                                  rightComponent={
                                    this.state.search === '' ? (
                                      <Button
                                        size="small"
                                        basic
                                        primary
                                        onClick={e => this.props.onItemClick(e, [lawyer.id])}
                                        content={isExisted ? 'Added' : 'Add'}
                                        disabled={this.handleOnCheck(lawyer) || isExisted || isLimit}
                                      />
                                    ) : null
                                  }
                                />
                              </Table.Cell>
                            </Table.Row>
                          );
                        })
                      }
                    </Table.Body>
                  </Table>
                ) : (
                  <Segment textAlign="center">
                    {
                      this.state.loading ?
                        <Loader active inline="centered">Loading</Loader>
                      : 'No lawyer found.'
                    }
                  </Segment>
                )
              }
              {
                this.state.data.length > 0 && this.state.hasMore ? (
                  <Segment basic textAlign="center">
                    <Button
                      onClick={this.handleLoadMore}
                      content="Load more"
                    />
                  </Segment>
                ) : null
              }
            </Grid.Column>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          {
            this.props.selectLimit && this.props.selectLimit > 0 &&
            (this.state.oriSelected.length < this.props.selectLimit) ? (
              <LimitCounter
                current={this.state.selected.length}
                limit={this.props.selectLimit - this.state.oriSelected.length}
                primaryText="lawyers"
              />
            ) : null
          }
          <Button
            primary
            onClick={this.handleOnConfirm}
            icon="checkmark"
            content="Add"
            disabled={isLimit || this.state.selected.length < 1}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/LawyersList.jsx